import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';
import { menuSidebarSelector } from '@reducers/menuSidebar/menuSidebarSlice';

import Routes from './config/Routes';
import HeaderTags from './config/HeaderTags';
import GlobalStyles from './styles/global';
import theme from './styles/theme';

function App() {
  const { openedSidebar } = useSelector(menuSidebarSelector);

  return (
    <>
      <HeaderTags />
      <GlobalStyles />
      <ThemeProvider theme={{ ...theme, openedSidebar }}>
        <Routes />
      </ThemeProvider>
    </>
  );
}

export default App;
